export default {
  CLEAR:     '@@error/CLEAR',
  CLEAR_API: '@@error/CLEAR_API',
  NEW:       '@@error/NEW',
  NEW_API:   '@@error/NEW_API'
};
